import React, { useState, useEffect } from 'react';
import PrinterForm from './PrinterForm'
import { Paper, withStyles, Dialog } from '@material-ui/core';
import History from "../../../History";
import * as Yup from "yup";
import { parseURL } from "../../sc-utilities";
import { snackActions } from '../../sc-utilities/SnackBar';
import * as actions from './store/printerActions';
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import { isValidPrinterAddress } from './printer.utility';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const types = [
    { value: 'zebra', displayValue: 'Zebra' },
    { value: 'godex', displayValue: 'Godex' },
    { value: 'brother', displayValue: 'Brother' },
    { value: 'dymo', displayValue: 'Dymo' }
];

const PrinterEdit = props => {
    const { classes, onFetchPrinterInit, onFetchPrinter, printer, onEditPrinter, activeCustomer, translations, permissions, editing } = props;
    const [data, setData] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await onFetchPrinter({ PrinterID: parseURL(window.location.href).PrinterID, ActiveCustomerID: activeCustomer });
            setData(false)
        }
        fetchData();
        return () => {
            onFetchPrinterInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const workProduct = printer?.LabelTemplates?.filter((product)=> product?.ProductType === "PCProduct")?.[0];
    const mobileProduct = printer?.LabelTemplates?.filter((product)=> product?.ProductType === "MobileProduct")?.[0];
    const watchProduct = printer?.LabelTemplates?.filter((product)=> product?.ProductType === "WatchProduct")?.[0];
    const headphoneProduct = printer?.LabelTemplates?.filter((product)=> product?.ProductType === "HeadphoneProduct")?.[0];

    let initialValues = {
        Name: printer.Name || "",
        PrinterType: printer.PrinterType || types[0].value,
        ConnectionType: printer.ConnectionType || '',
        URI: printer.URI || '',
        DirectPrinter: printer.DirectPrinter === 1 ? true : false,
        WorkLabelTemplateID: workProduct?.LabelTemplateID || "",
        MobileLabelTemplateID: mobileProduct?.LabelTemplateID || "",
        WatchLabelTemplateID: watchProduct?.LabelTemplateID || "",
        HeadphoneLabelTemplateID: headphoneProduct?.LabelTemplateID || "",
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            PrinterType: Yup.string().required("Required"),
            ConnectionType: Yup.string().required("Required"),
            URI: Yup.string().when("ConnectionType", {
                is: val => val === 'network',
                then: Yup.string().required('Required')
            }),
            DirectPrinter: Yup.bool().required("Required"),
            WorkLabelTemplateID: Yup.string(),
            MobileLabelTemplateID: Yup.string(),
            WatchLabelTemplateID: Yup.string(),
            HeadphoneLabelTemplateID: Yup.string()
        },
        FormTitle: translations["edit_printer"] || "Edit printer",
        ButtonSubmit: hasPermission(permissions, "printer_save") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    const handleSubmit = formData => {
        formData['PrinterID'] = printer.PrinterID;
        const {MobileLabelTemplateID, WorkLabelTemplateID, WatchLabelTemplateID, HeadphoneLabelTemplateID, ...restData} = formData;
        if (restData.ConnectionType === 'network' && !isValidPrinterAddress(formData)) {
            snackActions.snackBarComponent(translations['printer_address'] || 'Printer address is invalid.', 'warning');
            return;
        }
        let result = onEditPrinter({ ...restData, ActiveCustomerID: activeCustomer, LabelTemplates: [ WorkLabelTemplateID, MobileLabelTemplateID, WatchLabelTemplateID, HeadphoneLabelTemplateID ] });
        if (result) {
            History.goBack();
        }
    }

    return (
        <Paper className={classes.root}>
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={false} open={data}
                PaperProps={
                    {
                        classes: {
                            root: classes.paper
                        }
                    }
                }
            >
                <AppLogoLoading />
            </Dialog>
            {BackButton(translations)}
            {
                !data ?
                    <PrinterForm
                        formSettings={formSettings}
                        initialValues={initialValues}
                        types={types}
                        handleSubmit={handleSubmit}
                        translations={translations}
                        loading={editing}
                        activeCustomer={activeCustomer}
                    /> : null
            }
        </Paper>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        printer: state.setting.printers && state.setting.printers.loaded ? state.setting.printers.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        editing: state.setting.printers.editing
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchPrinter: printer => dispatch(actions.loadPrinter(printer)),
        onEditPrinter: printer => dispatch(actions.editPrinter(printer)),
        onFetchPrinterInit: printer => dispatch(actions.loadPrinterInit(printer))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PrinterEdit));

